import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { useStore } from '@/store';
import types from '@/store/types';
import { useGlobalData } from '@/hooks/useGlobalData';
import PageHeader from '@/components/PageHeader/index.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const global = useGlobalData();

const title = computed(() => store.state.title);

const shareCode = getQuery('code'); // 取url上的参数

if (shareCode) {
  // 有链接时候，设置标识
  store.commit(types.SET_SHARE_CODE, shareCode);
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(global).isKuaikan)
      ? (_openBlock(), _createBlock(PageHeader, {
          key: 0,
          title: _unref(title)
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}
}

})